var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / edt-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2658 4.42909C20.7018 4.85573 20.7095 5.5628 20.2828 5.99877L19.2477 7.05655L17.0535 4.90935L18.0886 3.85157C18.5153 3.4156 19.2223 3.40794 19.6583 3.83459L20.2658 4.42909Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1699 5.82002L9.28993 12.85L9.12993 15.22L11.4799 15L18.3699 7.96002L16.1699 5.82002Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8199 19.82H4.17993V4.18002H12.9499V5.98002H5.97993V18.02H18.0199V12.36H19.8199V19.82Z",
    fill: "#262626"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/editSquare.afe3f32a7c215bbdf910ca1884c28ad2.svg";
export { ForwardRef as ReactComponent };